import { IItinerarymap } from "@eventr/common";

export const removeOldItineraryData = (itineraryMap: IItinerarymap[]) => {
  const idsToKeep = itineraryMap.map((i) => Number.parseInt(i.id.toString()));
  const keysToRemove = [];
  for (let i = 0, len = localStorage.length; i < len; ++i) {
    const key = localStorage.key(i);
    if (key && key.startsWith("ItineraryDataForID:")) {
      const id = Number.parseInt(key.replace("ItineraryDataForID:", ""));
      if (!idsToKeep.includes(id)) {
        keysToRemove.push(localStorage.key(i));
      }
    }
  }

  keysToRemove.forEach((key) => {
    if (key !== null) {
      localStorage.removeItem(key);
    }
  });
};
